import { Component } from '@angular/core';
import { Order, OrderDTO } from '@app/data-interfaces';
import { OrderService } from '@pisci/data-orders';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.scss'],
})
export class MyOrdersComponent {
  myorders$:Observable<Order[]>;
  showOrderId = '';
  orderToShow?:Order = undefined;
  orderDTOToShow?:OrderDTO = undefined;
  public constructor(private orderService: OrderService) {
    this.myorders$ = this.orderService
      .getMyOrders()
      .pipe(
        map((orders) => orders.filter((order) => order['status'] != 'draft')),
      );
  }

  readablePaymentMethod(method: string) {
    if (method == 'invoice') {
      return 'Rechnung';
    }
    if (method == 'stripe') {
      return 'Online-Zahlung';
    }
    return '';
  }

  readableStatus(status:string){
    switch(status){
      case "on-hold":
        return "Bestellung";
      case "paid":
        return "Bestellung";
      case "canceled":
        return "Storniert";
    }
    return "";
  }
  showOrder(order: Order) {
    console.log(order.id, this.showOrderId);


    if (this.showOrderId == order.id + '') {
      this.showOrderId = '';
      return;
    }
    this.showOrderId = '';
    this.orderDTOToShow = undefined;
    this.orderToShow = undefined;

    this.orderService.getOrderDTO(order.id).subscribe( (orderDTO) => {
      this.orderToShow = order;
      this.orderDTOToShow = orderDTO;
      this.showOrderId = '' + order.id ?? '0';
    });

  }
}
